function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
  
function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
    }
    return "";
}

function convertToSlug(Text) {
  return Text.toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}


// Detect swipe events
function detectSwipe(element, callback) {
    let touchStartX = 0;
    let touchEndX = 0;

    $(element).on('touchstart', function(event) {
        touchStartX = event.originalEvent.touches[0].pageX;
    });

    $(element).on('touchend', function(event) {
        touchEndX = event.originalEvent.changedTouches[0].pageX;
        handleSwipe();
    });

    function handleSwipe() {
        if (touchEndX < touchStartX) {
            callback('left');
        }
        if (touchEndX > touchStartX) {
            callback('right');
        }
    }
}


function isIOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}



(function($){
  var widowHeight = '';
  var topElement = '';
  var isBannerTop = 0;
  var bannerBottom = 0;
  setCookie('isBannerTop', 0, 1);
  setCookie('bannerBottom', 0, 1);
  
  $(document).ready(function(){
     if($('.collection-description table, .product-info__description table').length){
        $('.collection-description table, .product-info__description table').wrap('<div class="table-wrapper"></div>');
      }

    // if (isIOS() == true) {
    //     jQuery('body').addClass('ios-device');
    // }

    var ua = navigator.userAgent.toLowerCase(); 
        if (ua.indexOf('chrome') > - 1) { 
            
          
        }else{
            $('body').addClass('ios-device');
        }

    //add --height header for body
    var header_height = $('header').outerHeight();
    $('body').css('--height-header', header_height + 'px');

    //add --height footer for body
    var header_footer = $('footer .footer').outerHeight();
    $('body').css('--height-footer', header_footer + 'px');

    
    // Hide button Swiper in Location page
    detectSwipe($('.table-wrapper table')[0], function(direction) {
        if (jQuery(window).width() <= 767) {
            $('body').addClass('hide-swiper');      
        }
    });
    $('.table-wrapper table').click(function(){
        if (jQuery(window).width() <= 767) {
            $('body').addClass('hide-swiper');      
        }
    });
    $(' .table-wrapper').scroll(function(){
        if (jQuery(window).width() <= 767) {
            $('body').addClass('hide-swiper');      
        }
    });
    
  
      $('.js store-header.header[allow-transparency] .header__logo-image').on('mouseenter', function(){
        console.log('hover');
        $('.js .header[allow-transparency]').addClass('show-background');
        setTimeout(function(){
          $('.js .header[allow-transparency]').addClass('show-menu');
        }, 400)
      });

      // if ($('store-header.header').length) {
      //     $('#main').css('padding-top', $('store-header.header').height() + 'px');
      // }
  
      if($('.shopify-section--blog-posts .blog-post-card__info h7').length){
        $('.shopify-section--blog-posts .blog-post-card__info h7').matchHeight();
      }


      widowHeight = $(window).height();
      topElement = (widowHeight / 2) - ($('.images-scrolling-desktop__media-wrapper').height() / 2);
      $('.images-scrolling-desktop__media-wrapper').css('top', topElement);
  
  
      // Show hide menu, submenu, menu heading
      var mouseInMenu = 0;
      jQuery('.navigation-drawer').on('mouseenter focus', function(){
          mouseInMenu = 1;
      });
      jQuery('.navigation-drawer').on('mouseleave blur', function(){
          mouseInMenu = 0;
      });
      jQuery('body *:not(.header__link-list>.contents>li>button, .navigation-drawer .panel-list__wrapper > .panel .menu-lv-1').click(function(){
          if (mouseInMenu == 0) {
              jQuery('.panel_buttons h5').remove();
          }
      });
      
      jQuery('body').on('click','.header__link-list>.contents>li>button',function(){
          let menuSlug = convertToSlug(jQuery(this).text().trim());
          jQuery('.navigation-drawer[mega-menu]').attr('data-parent', menuSlug);
          if (jQuery('.navigation-drawer[mega-menu] .panel__scroller .panel_buttons h5').length == 0) {
              let menuHeading = '<h5>'+jQuery(this).text()+'</h5>';
              jQuery('.navigation-drawer[mega-menu] .panel__scroller .panel_buttons').append(menuHeading);
          }else{
              jQuery('.navigation-drawer[mega-menu] .panel__scroller .panel_buttons h5').text(jQuery(this).text());
          }
      });
      
      jQuery('body').on('click', 'navigation-drawer .panel-list__wrapper > .panel .menu-lv-1 > button', function(){
          if (jQuery('body > navigation-drawer .panel_buttons h5').length == 0) {
              let menuHeading = '<h5>'+jQuery(this).text()+'</h5>';
              jQuery('body > navigation-drawer .panel_buttons').append(menuHeading);
          }else{
              let menuHeading = jQuery(this).text();
              jQuery('body > navigation-drawer .panel_buttons h5').text(menuHeading);
          }
      });
      
      jQuery('body').on('click','.navigation-drawer[mega-menu] [is=close-button], .header__main-nav .header__icon-list .tap-area', function() {
           jQuery('.panel_buttons h5').remove();
      });

      //active menu
      if (window.location.pathname) {
          jQuery('navigation-drawer .panel__wrapper li a').each(function(){
              if (jQuery(this).attr('href') == window.location.pathname) {
                  jQuery(this).parent().addClass('active');
              }
          });
      }

      //change header height
      if (jQuery('body.template-index').length == 0){
          if (jQuery('.header__wrapper').length) {
              var offsetBeforeChanging = parseInt(document.querySelector('.header__wrapper').offsetHeight) / 2;
              if (jQuery(window).scrollTop() > offsetBeforeChanging) {
                   jQuery('store-header').addClass('is-filled');
              }else{
                   jQuery('store-header').removeClass('is-filled');
              }
          }
      }

      // check banner video exist and banner at top
      if (jQuery('.shopify-section--banner-video').length) {
          if (jQuery('.shopify-section--banner-video').offset().top <= 0) {
              isBannerTop = 1;
              setCookie('isBannerTop', 1, 1);
              bannerBottom = jQuery('.shopify-section--banner-video').offset().top + jQuery('.shopify-section--banner-video').height();
              setCookie('bannerBottom', bannerBottom, 1);
          }
      }

      // Show/hide search menu when type in search
      jQuery('.search-drawer .search-input>input').keyup(function(){
          if (jQuery(this).val() != '') {
              jQuery('.search-drawer .search-menu-wrapper').hide();
          } else {
              jQuery('.search-drawer .search-menu-wrapper').show();
          }
      });

      jQuery('.search-drawer .search-input-wrapper button[is="close-button"]').click(function(){
          if (jQuery('.search-drawer .search-input>input').val() == ''){
              jQuery('.search-drawer .search-menu-wrapper').show();  
          }
      });
      jQuery('.search-drawer .search-input>button[type="reset"]').click(function(){
          jQuery('.search-drawer .search-menu-wrapper').show();
      });

    jQuery('div#directory .search-wrapper input').keyup(function(){
           jQuery(this).closest(".search-wrapper").addClass('show');
      });

    jQuery('div#directory .search-wrapper button[type="reset"]').click(function(){
          jQuery('div#directory .search-wrapper input').val("");
          jQuery(this).closest(".search-wrapper").removeClass('show');
      });


    // jQuery('.accordion:nth-child(1)').attr('aria-expanded', 'true');
    // jQuery('.accordion:nth-child(1)').attr('open', '');
    // jQuery('.accordion:nth-child(1)').css({"overflow": "visible", "height": "auto"});
    // jQuery('.accordion:nth-child(1)').find('.accordion__content').css({"opacity": "1", "transform": "translateY(-4px)"});
    
  });

  
  $(document).on('mouseover', function(event) {
    if (!$(event.target).closest('.js .header[allow-transparency], .navigation-drawer[mega-menu]').length) {
      if(!$('.header').hasClass('scroll-up')){
        if($('.js .header[allow-transparency]').hasClass('show-menu')){
          $('.js .header[allow-transparency]').removeClass('show-menu');
        }
        if($('.js .header[allow-transparency]').hasClass('show-background')){
          setTimeout(function(){
            $('.js .header[allow-transparency]').removeClass('show-background');
          }, 400)
        }
      }
    }
  });

  
  $(window).on('load change resize orientationchange', function() {

        //add --height header for body
    var header_height = $('header').outerHeight();
    $('body').css('--height-header', header_height + 'px');

    //add --height footer for body
    var header_footer = $('footer .footer').outerHeight();
    $('body').css('--height-footer', header_footer + 'px');
    
    widowHeight = $(window).height();
    widowHeight = $(window).height();
    topElement = (widowHeight / 2) - ($('.images-scrolling-desktop__media-wrapper').height() / 2);
    $('.images-scrolling-desktop__media-wrapper').css('top', topElement);
  });

  
  
  var lastScrollTop = 0;
  $(window).scroll(function(event){
     var st = $(this).scrollTop();
    
     var headerAnchorTop = 0;
    
     if ($('#header-anchor').length) {
         var headerAnchorTop = $('#header-anchor').offset().top;  
     }
     
     // console.log(headerAnchorTop);
     clearTimeout(headerAnimation);
     var headerAnimation = setTimeout(function(){
          // header change height when scroll - home page
          if (st > 0){
              $('.js .header[allow-transparency]').addClass('change-height');
          }else{
              $('.js .header[allow-transparency]').removeClass('change-height');
          }

          // change header animation
          if (st > lastScrollTop){
              if($('.js .header[allow-transparency]').hasClass('show-menu')){
                $('.js .header[allow-transparency]').removeClass('show-menu');
              }
              if($('.js .header[allow-transparency]').hasClass('show-background')){
                setTimeout(function(){
                  $('.js .header[allow-transparency]').removeClass('show-background');
                }, 400)
              }
             
             if(headerAnchorTop <= $('.shopify-section--banner-video').height()){
                  // console.log('up banner');
                 $('.js .header[allow-transparency]').removeClass('change-color-nav');
                 $('.js .header[allow-transparency]').removeClass('is-filled');
             }else{
                 // console.log('down banner');
                 $('.js .header[allow-transparency]').addClass('change-color-nav');
                 $('.js .header[allow-transparency]').addClass('is-filled');
             }
             $('.js .header[allow-transparency]').removeClass('scroll-up');
           } else {
              // console.log('up');
              $('.js .header[allow-transparency]').addClass('show-background');
              setTimeout(function(){
                if(headerAnchorTop <= $('.shopify-section--banner-video').height()){
                    $('.js .header[allow-transparency]').removeClass('show-menu');
                }else{
                    $('.js .header[allow-transparency]').addClass('show-menu');
                }
              }, 400)
             if($('.shopify-section--banner-video').length){
               if(headerAnchorTop <= $('.shopify-section--banner-video').height()){
                  // console.log('change');
                 $('.js .header[allow-transparency]').removeClass('change-color-nav');
                 $('.js .header[allow-transparency]').removeClass('is-filled');
               }
             }
             $('.js .header[allow-transparency]').addClass('scroll-up');
      
           }
           lastScrollTop = st;
      },150);
         

      //change header height
      if (jQuery('body.template-index').length == 0){
          if (jQuery('.header__wrapper').length) {
              var offsetBeforeChanging = parseInt(document.querySelector('.header__wrapper').offsetHeight) / 2;
              if (st > offsetBeforeChanging) {
                   jQuery('store-header').addClass('is-filled');
              }else{
                   jQuery('store-header').removeClass('is-filled');
              }
          }
      }

  });


  // animation when scroll mini search
  const originalFetch = window.fetch;
  window.fetch = function() {
      setTimeout(function(){
         if ($('.predictive-search__tab-content').length) {
            let seasrchLastScrollTop = 0;
            $('.predictive-search__tab-content').scroll(function() {
                let st = $(this).scrollTop();
                if (st > 0) {
                    $(this).closest(".search-drawer").addClass('scrolled');
                }else{
                    $(this).closest(".search-drawer").removeClass('scrolled');
                }
                seasrchLastScrollTop = st;
                jQuery(this).attr('data-scroll', st);
            });
          }
      }, 1000);
      return originalFetch.apply(this, arguments);
  };

  jQuery('body').on('click', '.search-drawer .predictive-search__tab-item', function(){
      if (parseInt(jQuery(this).next().attr('data-scroll')) > 0) {
          jQuery(this).closest(".search-drawer").addClass('scrolled');
      }else{
          jQuery(this).closest(".search-drawer").removeClass('scrolled');
      }
  });

  
  

  $(window).on('load', function() {
      AOS.init({
          once: true,
          duration: 800,
      });
  });


/*============================================================================
  Filter Table
==============================================================================*/
// <![CDATA[
$("#filterTableInput").keyup(function () {
    // Split the current value of the filter textbox
    var data = this.value.split(" ");
    // Get the table rows
    var rows = $("#fbody").find("tr");
    if (this.value == "") {
        rows.show();
        return;
    }
    
    // Hide all the rows initially
    rows.hide();

    // Filter the rows; check each term in data
    rows.filter(function (i, v) {
        for (var d = 0; d < data.length; ++d) {
            if ($(this).is(":contains('" + data[d] + "')")) {
                return true;
            }
        }
        return false;
    })
    // Show the rows that match.
    .show();
}).focus(function () { // style the filter box
    this.value = "";
    $(this).css({
        "color": "black"
    });
    $(this).unbind('focus');
}).css({
    "color": "#C0C0C0"
});

// make contains case insensitive globally
// (if you prefer, create a new Contains or containsCI function)
$.expr[":"].contains = $.expr.createPseudo(function(arg) {
    return function( elem ) {
        return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
});
// ]]>


  
})( jQuery );